
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecu",
      function () {
        return require("private-next-pages/ecu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecu"])
      });
    }
  